import { TelemetryEvent } from './telemetry-event';

export abstract class TelemetryErrorEvent extends TelemetryEvent {
	public readonly internalError: Error;
	public stack: string[];

	constructor(params: TelemetryErrorEventParams) {
		super('error');
		this.internalError = params?.internalError;
		const stack = new Error()?.stack;
		this.stack = stack?.split('\n');

	}
}

interface TelemetryErrorEventParams {
	internalError: Error;
}
